const getEnv = () => {
  const host = window.location.hostname.toLowerCase();

  if (host === 'localhost' || host === '127.0.0.1') {
    return 'development';
  }

  return 'production';
};

const ENV = getEnv();
const CONFIG = {
  development: {
    /** Main documentation orchestrator (api/main.py) — Clerk JWT required */
    EDS_BACKEND_URL: 'http://localhost:4002',
    CHECKPOINTS_URL: 'http://localhost:4002',
    QA_AGENT_URL: 'http://localhost:4002',
    ARTIFACTS_URL: 'http://localhost:4001',
  },
  production: {
    /** Doc API (api/main.py) — query, quota, checkpoints */
    EDS_BACKEND_URL: 'https://intdoc-agentapi-ibeam.optisolbusiness.com',
    CHECKPOINTS_URL: 'https://intdoc-agentapi-ibeam.optisolbusiness.com',
    QA_AGENT_URL: 'https://intdoc-agentapi-ibeam.optisolbusiness.com',
    ARTIFACTS_URL: 'https://intdoc-agentapi-ibeam.optisolbusiness.com',
  },
};
export const networkManager = CONFIG[ENV];
export const networkManagerEnv = ENV;
export { getEnv };
